export class CreateIndexField {
    constructor(indexFieldRepository) {
      this.indexFieldRepository = indexFieldRepository;
    }
  
    async execute(Fields) {
      return await this.indexFieldRepository.CreateIndexField(Fields);
    }
  }